import { gql } from "@apollo/client";

const ORGANIZATION_VIDEOS = gql`
  query organizationQuery(
    $id: ID!
    $take: Int
    $cursor: ID
    $filters: OrganizationMediaFilters
  ) {
    organization(id: $id) {
      id
      videosCount
      media(type: "VIDEO", take: $take, cursor: $cursor, filters: $filters) {
        id
        createdAt
        type
        subtype
        isExternal
        filename
        public
        aspectRatio
        clapCount
        isClapped
      }
    }
  }
`;

export default ORGANIZATION_VIDEOS;
